import { Router } from '@angular/router';
import { ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Component, Inject } from '@angular/core';
import { AuthService } from '../../auth.service'
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-request-password',
  templateUrl: './request-password.component.html',
  styleUrls: ['./request-password.component.scss']
})
export class RequestPasswordComponent implements OnInit {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};

  constructor( protected router: Router, private auth: AuthService, private toast: NbToastrService ) {


  }

  ngOnInit() {
  }

  async requestPass() {

    let  passreset=  await this.auth.resetPassword(this.user.email);

     if (passreset=="e-mail sent") {
     }
     else {
     }
    this.errors = this.messages = [];
    this.submitted = true;


  }
}
